module.exports = __webpack_public_path__ + "img/list-item.ff68663b.png";